export function unique(value, index, self) {
    return self.indexOf(value) === index;
  }